export default __webpack_public_path__ + "static/media/016-snowman.b1e5862f.svg";